import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";

export const WASTE_CLASSIFICATION_EXPLANATION_QUERY = gql(`
  query WasteClassificationExplanation($wasteLineUnifiedId: ID!) {
    complianceEngineWasteLineExplanation(wasteLineUnifiedId: $wasteLineUnifiedId) {
      wasteLineUnifiedId
      streamWasteKind
      facilityContext {
        state
        subpartP
        txSteersGeneratorType
      }
      inputs {
        federalCodes
        stateCodes
        description
        managementMethodCode
        finalManagementMethodCode
      }
      result {
        classification
        wasteKind
        universalWasteCategory
        willNotReport
        willNotReportSource
        reportableOnFederalBiennial
        subjectToEManifest
        reportableToState
        countsTowardGeneratorStatus {
          federal
          state
        }
      }
      reasons {
        field
        description
      }
    }
  }
`);

export function useWasteClassificationExplanation(wasteLineUnifiedId: string) {
  const { data, loading, error } = useQuery(WASTE_CLASSIFICATION_EXPLANATION_QUERY, {
    variables: { wasteLineUnifiedId },
    // The line's inputs are editable elsewhere in the app, so revalidate on
    // every open rather than serve a cached explanation.
    fetchPolicy: "cache-and-network",
  });

  return {
    explanation: data?.complianceEngineWasteLineExplanation,
    loading,
    error,
  };
}

export const PIPELINE_ROW_CLASSIFICATION_EXPLANATION_QUERY = gql(`
  query PipelineRowClassificationExplanation($pipelineOutputId: ID!) {
    complianceEnginePipelineRowExplanation(pipelineOutputId: $pipelineOutputId) {
      pipelineOutputId
      facilityContext {
        state
        subpartP
        txSteersGeneratorType
      }
      inputs {
        federalCodes
        stateCodes
        description
        managementMethodCode
        finalManagementMethodCode
      }
      result {
        classification
        wasteKind
        universalWasteCategory
        willNotReport
        willNotReportSource
        reportableOnFederalBiennial
        subjectToEManifest
        reportableToState
        countsTowardGeneratorStatus {
          federal
          state
        }
      }
      reasons {
        field
        description
      }
    }
  }
`);

export function usePipelineRowClassificationExplanation(pipelineOutputId: string) {
  const { data, loading, error } = useQuery(PIPELINE_ROW_CLASSIFICATION_EXPLANATION_QUERY, {
    variables: { pipelineOutputId },
    fetchPolicy: "cache-and-network",
  });

  return {
    explanation: data?.complianceEnginePipelineRowExplanation,
    loading,
    error,
  };
}
